import React from 'react'

import Button from "@mui/material/Button/Button"
import PR from "../../../../assets/images/pr.jpg"

import "./Program.scss"

const Program = () => {
    return (
        <>
            <div className="program_container">
                <div className="box">
                    <div className="img_box">
                        <img src={PR} alt="ERROR" />
                    </div>
                    <div className="data">
                        <div className="title">
                            Sandaga Education Program
                        </div>
                        <div className="detail"> NFT, blockchain & cryptos for all  </div>
                        <div className="dis">
                            The Sandaga Education Program (S.E.P.) is our in-house charity program, it will help creators from all around the world, specifically from developing countries, providing them with an opportunity to benefit from the Blockchain's innovative technology.
                        </div>
                        <div className="dis">
                            This program is led by our co-founder Hélène SY, she has a huge experience in charities as the C.E.O. of <a href="#" style={{ color: "#17c6ff" }}> CéKeDuBonheur </a> a well-known French charity helping child in hospitals.
                        </div>
                        <div className="dis">
                            3% of our revenues are redistributed to our Sandaga Education Program.
                        </div>
                        <Button style={{ color: "#0FFFF7",  border:"2px solid #0FFFF7", backgroundColor: "#000000", width: "200px" }}> Learn more </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Program
